import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import moment from "moment";
import LinesEllipsis from "react-lines-ellipsis";
import Skeleton from "react-loading-skeleton";

const NewsAlt = ({ full, data, loading }) => {
  const [news, setNews] = useState([]);

  useEffect(() => {
    if (data?.length > 0) {
      setNews(data);
    }
  }, [data, data?.length]);

  const dataLoading = [1, 2, 3, 4, 5, 6];

  return (
    <div className="news__alt">
      {!full && <h2 className="featured__header__main">Latest News</h2>}

      <div className="news__alt__main">
        {loading ? (
          <>
            {dataLoading?.map((item) => {
              return (
                <div key={item} className="news__alt__main__item">
                  <div style={{ marginBottom: 10 }}>
                    <Skeleton height={150} />
                  </div>
                  <Skeleton count={4} />
                </div>
              );
            })}
          </>
        ) : (
          <>
            {news?.map((item) => {
              return (
                <Link key={item?.id} to={`/news/${item?.slug}`}>
                  <div className="news__alt__main__item">
                    <div className="news__alt__main__item__img">
                      <img
                        src={process.env.REACT_APP_API_URL + item?.coverUrl}
                        alt=""
                      />
                    </div>
                    <div className="news__alt__main__item__cont">
                      <div className="news__alt__main__item__cont__top">
                        <Link to={`/news?tag=${item?.tag?.replace(/ /g, "_")}`}>
                          <span className="news__alt__main__item__cont__top__tag">
                            {item?.tag}
                          </span>
                        </Link>

                        <p>
                          <i className="bx bx-calendar-alt"></i>{" "}
                          {moment(item?.createdAt).format("Do MMM, YYYY")}
                        </p>
                      </div>

                      <h3 className="alt">
                        <LinesEllipsis
                          text={item?.title}
                          maxLine="2"
                          ellipsis="..."
                          trimRight
                          basedOn="letters"
                        />
                      </h3>

                      <p className="news__alt__main__item__cont__desc">
                        <LinesEllipsis
                          text={item?.summary}
                          maxLine="3"
                          ellipsis="..."
                          trimRight
                          basedOn="letters"
                        />
                      </p>
                    </div>
                  </div>
                </Link>
              );
            })}
          </>
        )}
      </div>

      <div className="news__alt__btn">
        <Link to="/news">
          <button className="btn">View More</button>
        </Link>
      </div>
    </div>
  );
};

export default NewsAlt;
